import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Counter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            incInterval:        null,
            incNumber:          0,
            amount:             0,
            frequency:          12,
            target:             props.target,
            duration:           props.duration,
            transformFunction:  props.transformFunction,
            onCount:            props.onCount
        };

        this.increment = this.increment.bind(this);
    }

    componentDidMount() {
        const duration = this.state.duration;
        const frequency = this.state.frequency;
        const target = this.state.target;

        this.setState({incNumber: target/(duration/frequency) });
        this.setState({incInterval: setInterval(this.increment, this.state.frequency)});
    }

    componentWillUnmount() {
        clearInterval(this.state.incInterval);
    }

    increment() {
        this.setState({amount: this.state.amount + this.state.incNumber});
        if (this.state.onCount){
            this.state.onCount(this.state.amount);
        }
        if (this.state.amount >= this.state.target) {
            this.setState({amount: this.state.target});
            clearInterval(this.state.incInterval);
        }
    }
    
    render(){
        return (
            <span>
                {this.state.transformFunction(this.state.amount)}
            </span>
        );
    }
}

Counter.propTypes = {
    target:             PropTypes.number,
    duration:           PropTypes.number,
    transformFunction:  PropTypes.func,
    onCount:            PropTypes.func
};

Counter.defaultProps = {
    target: 0,
    duration: 0,
    transformFunction: (number) => {
        return number;
    }
};

export default Counter;